import React, { useRef, useState } from 'react'
import { Form, Container, Card, Alert } from 'react-bootstrap'
import { useAuth } from '../contexts/AuthContext'
import { Link, useHistory } from 'react-router-dom'
import Logo from '../image/logo/logo-liberhash.png'

export default function Signup() {

    //const nameRef = useRef()
    const emailRef = useRef()
    const passwordRef = useRef()
    const passwordConfirmRef = useRef()
    const { signup } = useAuth()
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const history = useHistory()

    async function handleSubmit(e){
        e.preventDefault();

        if(passwordRef.current.value !== passwordConfirmRef.current.value){
            return setError('Las contraseñas no coinciden');
        }
        
        if (passwordRef.current.length < 6){
            return setError('La contraseña debe tener mínimo 6 caracteres');
        }

        try {
            setError('')
            setLoading(true)
            await signup(emailRef.current.value, passwordRef.current.value)
            history.push("/")
        } catch {
           setError("La contraseña debe tener mínimo 6 caracteres") 
        }
        setLoading(false)
    }


    return (
        <>
            <Container className="d-flex align-items-center justify-content-center" style={{minHeight:"100vh"}}>
                <div className="container h-100 my-3">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col-xl-12">
                            <div className="row g-0 d-flex">
                                <div className="col-lg-6">
                                    <Card className="rounded-start">
                                        <Card.Body className="p-5 rounded-start">
                                            <div className="text-center py-2">
                                                <img src={Logo} style={{ width: 250 }} alt="Logo LiberHash"></img>
                                            </div>
                                            <p className="text-center mb-3">Resgistrate en LiberHash</p>
                                            {error && <Alert variant="danger">{error}</Alert>}
                                            <Form onSubmit={handleSubmit}>
                                                <Form.Group id="email">
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control type="email" ref={emailRef} required />
                                                </Form.Group>
                                                <Form.Group id="password">
                                                    <Form.Label>Contraseña</Form.Label>
                                                    <Form.Control type="password" ref={passwordRef} required />
                                                </Form.Group>
                                                <Form.Group id="password-confirm">
                                                    <Form.Label>Confirmar contraseña</Form.Label>
                                                    <Form.Control type="password" ref={passwordConfirmRef} required />
                                                </Form.Group>
                                                <button disable={ setLoading.toString(loading) } className="w-100 mt-3 nav__btn btn-block fa-lg mb-3"  type="submit">Registrarse</button>
                                            </Form>
                                            <div className="w-100 text-center mt-2">
                                                ¿Ya estás registrado? <Link to="/login" style={{color: '#ffa900'}}>Inicia sesión</Link>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                                <div className="col-lg-6 d-flex align-items-center gradient-custom-2">
                                    <div className="text-white px-3 py-4 p-md-5 mx-md-4">
                                        <h4 className="mb-4 fs-2">Somos tu conexión con la economía 4.0</h4>
                                        <p className="small mb-0">Los especuladores y la volatilidad son nuestros amigos, cuanto más haya, mejores resultados obtendremos a largo plazo.</p>
                                        <h4 className="small mb-0 mt-2">WARREN BUFFETT</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </>
    )
}
